import f from "./_castPath.js";
import l from "./isArguments.js";
import e from "./isArray.js";
import h from "./_isIndex.js";
import u from "./isLength.js";
import o from "./_toKey.js";
var g = f, _ = l, d = e, p = h, v = u, x = o;
function A(r, s, m) {
  s = g(s, r);
  for (var n = -1, i = s.length, t = !1; ++n < i; ) {
    var a = x(s[n]);
    if (!(t = r != null && m(r, a)))
      break;
    r = r[a];
  }
  return t || ++n != i ? t : (i = r == null ? 0 : r.length, !!i && v(i) && p(a, i) && (d(r) || _(r)));
}
var q = A;
export {
  q as default
};
//# sourceMappingURL=_hasPath.js.map
